import { Injectable, signal } from '@angular/core';

/** README: "los toasts duran ≥ 2 s". Una duración menor se sube a ésta. */
export const MIN_TOAST_MS = 2000;

interface ToastItem {
  message: string;
  durationMs: number;
}

/**
 * Cola de avisos breves: uno a la vez, para que el lector de pantalla los anuncie todos. Los pinta
 * `ui-toast-host`, que el shell monta una sola vez.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly currentMessage = signal<string | null>(null);
  private readonly queue: ToastItem[] = [];
  private active = false;

  readonly message = this.currentMessage.asReadonly();

  show(message: string, options?: { durationMs?: number }): void {
    this.queue.push({ message, durationMs: Math.max(options?.durationMs ?? MIN_TOAST_MS, MIN_TOAST_MS) });
    if (!this.active) this.next();
  }

  private next(): void {
    const item = this.queue.shift();
    if (!item) {
      this.active = false;
      this.currentMessage.set(null);
      return;
    }
    this.active = true;
    this.currentMessage.set(item.message);
    setTimeout(() => this.next(), item.durationMs);
  }
}
